import { Link } from 'react-router-dom';
import { useQuery } from 'react-query';

import LoadingImg from '@/assets/images/common/loading.png';
import WarningImg from '@/assets/images/icon/ico_alert.png';
import Pagination from '@/components/pagination';

import { useListQeury } from '../hook';

export default function PhotoList({ title }) {
  const listQuery = useListQeury();
  const { data: photoList, isError, isLoading } = useQuery(listQuery());

  if (isLoading) {
    return (
      <div className="photo-gallery__loading">
        <img src={LoadingImg} alt="loading" />
        <p>now Loading...</p>
      </div>
    );
  }
  if (isError || !photoList?.items.length) {
    return (
      <div className="photo-gallery__warning">
        <img src={WarningImg} alt="warning" />
        <p>There is no {title} yet</p>
      </div>
    );
  }

  return (
    <>
      <ul className="photo-gallery__list">
        {photoList.items.map((item) => (
          <li key={item.photoId}>
            <Link
              to={(location) => {
                const search = new URLSearchParams(location.search);

                search.set('photoId', item.photoId);

                return { ...location, search: search.toString() };
              }}
              className="photo-gallery__link"
            >
              <img src={item.thumbnail} alt={item.title} width={305} height={171} />
              <h3>{item.title}</h3>
              <time className="time-fs-fixed">{item.registDate}</time>
            </Link>
          </li>
        ))}
      </ul>
      <Pagination totalPages={photoList.totalPages} />
    </>
  );
}
